import {
  IRole,
  IRoleCreate,
  IRoleTable,
  IPagedData,
  IPagedSearch,
  TableStatus,
  IRoleSelect,
} from '@evencel/models';
import { Selectable } from '@evencel/ui';

export class GetRole {
  public static readonly type = '[Role] GetRole';
  constructor(public id: string) {}
}

export class ActivateRole {
  public static readonly type = '[Role] ActivateRole';
  constructor(public role: IRoleTable) {}
}

export class SearchRoles {
  public static readonly type = '[Role] SearchRoles';
  constructor(public data: IPagedSearch) {}
}

export class CreateRole {
  public static readonly type = '[Role] SaveRole';
  constructor(public role: IRoleCreate) {}
}

export class UpdateRole {
  public static readonly type = '[Role] UpdateRole';
  constructor(public role: IRole) {}
}

export class DeleteRole {
  public static readonly type = '[Role] DeleteRole';
  constructor(public role: IRoleTable) {}
}

export class RestoreRole {
  public static readonly type = '[Role] RestoreRole';
  constructor(public role: IRoleTable) {}
}

export class GetRolesResponse {
  public static readonly type = '[Role] GetRolesResponse';
  constructor(
    public pagedData: IPagedData<IRole>,
    public status: TableStatus
  ) {}
}

export class RoleSelected implements Selectable<IRoleSelect> {
  public static readonly type = '[Role] RoleSelected';
  constructor(public item: IRoleSelect, public durty = false) {}
}

export class RoleDeselected implements Selectable<IRoleSelect> {
  public static readonly type = '[Role] RoleDeselected';
  constructor(public item: IRoleSelect) {}
}

export class GetRoleResponse {
  public static readonly type = '[Role] GetRoleResponse';
  constructor(public role: IRole) {}
}
